import { type ReactNode } from 'react'
import { motion } from 'motion/react'

export function PageFrame({
  title,
  subtitle,
  action,
  children,
}: {
  title: string
  subtitle?: string
  action?: ReactNode
  children: ReactNode
}) {
  return (
    <motion.div
      key={title}
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.32, ease: [0.16, 1, 0.3, 1] }}
      className="flex-1 flex flex-col min-h-0"
    >
      <div className="px-5 pt-4">
        <div className="rule w-10" />
        <div className="flex items-end justify-between mt-2.5">
          <div className="min-w-0">
            <h1 className="display text-[44px] leading-[0.86]">{title}</h1>
            {subtitle && <div className="label mt-2">{subtitle}</div>}
          </div>
          {action}
        </div>
      </div>
      <div className="flex-1 min-h-0 overflow-y-auto mt-5 pb-8">{children}</div>
    </motion.div>
  )
}
